export const CHANGE_AVATAR_REQUEST = "changeAvatarReducer/CHANGE_AVATAR_REQUEST";
export const CHANGE_AVATAR_SUCCESS = "changeAvatarReducer/CHANGE_AVATAR_SUCCESS";
export const CHANGE_AVATAR_FAILED = "changeAvatarReducer/CHANGE_AVATAR_FAILED";
export const CHANGE_AVATAR_RESET = "changeAvatarReducer/CHANGE_AVATAR_RESET";
